"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var renderer_1 = require("@react-pdf/renderer");
var luxon_1 = require("luxon");
var React = __importStar(require("react"));
var Card_1 = __importDefault(require("../Card"));
var CardAttribute_1 = __importDefault(require("../CardAttribute"));
var math = __importStar(require("mathjs"));
var style = renderer_1.StyleSheet.create({
    text: {
        fontFamily: "Quicksand",
        fontSize: 10,
    },
});
var SampleInfoCard = function (_a) {
    var _b, _c, _d;
    var sample = _a.sample;
    return (React.createElement(Card_1.default, { style: { width: 200, paddingVertical: 5, marginBottom: 5 } },
        React.createElement(renderer_1.Text, { style: style.text }, "Sample"),
        React.createElement(CardAttribute_1.default, { title: "Account", value: sample.order.sampleSubmission.submittedBy.business.name }),
        React.createElement(CardAttribute_1.default, { title: "Sample ID", value: sample.sampleId }),
        React.createElement(CardAttribute_1.default, { title: "Sample Type", value: sample.matrix.sampleCategory.name }),
        React.createElement(CardAttribute_1.default, { title: "Sample Matrix", value: sample.matrix.name }),
        !!sample.weightOrCount && (React.createElement(CardAttribute_1.default, { title: "Batch Size", value: math.format(sample.weightOrCount, { precision: 10 }) + " " + sample.unitOfMeasure })),
        sample.accession.accessionAmount && (React.createElement(CardAttribute_1.default, { title: "Sample Size", value: math.format(sample.accession.accessionAmount.value, {
                precision: 10,
            }) + " " + (sample.accession.accessionAmount.units || "g") })),
        sample.accession.amountPerPackage && (React.createElement(CardAttribute_1.default, { title: "Package Size", value: math.format(sample.accession.amountPerPackage.value, {
                precision: 10,
            }) + " " + sample.accession.amountPerPackage.units })),
        sample.accession.amountPerServing && (React.createElement(CardAttribute_1.default, { title: "Serving Size", value: math.format(sample.accession.amountPerServing.value, {
                precision: 10,
            }) + " " + sample.accession.amountPerServing.units })),
        ((_b = sample.order.scheduledPickup) === null || _b === void 0 ? void 0 : _b.dateTime) && (React.createElement(CardAttribute_1.default, { title: "Collected Date", value: luxon_1.DateTime.fromISO(sample.order.scheduledPickup.dateTime).toLocaleString(luxon_1.DateTime.DATE_SHORT) })),
        React.createElement(CardAttribute_1.default, { title: "Received Date", value: luxon_1.DateTime.fromISO(sample.receivedAt).toLocaleString(luxon_1.DateTime.DATE_SHORT) }),
        React.createElement(CardAttribute_1.default, { title: "Completed Date", value: luxon_1.DateTime.fromISO((_d = (_c = sample.sampleApproval) === null || _c === void 0 ? void 0 : _c.approvedAt) !== null && _d !== void 0 ? _d : luxon_1.DateTime.local().toISO()).toLocaleString(luxon_1.DateTime.DATE_SHORT) })));
};
exports.default = SampleInfoCard;
//# sourceMappingURL=index.js.map